import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {concatMap} from 'rxjs/operators';
import {GlobalQuestionService} from '../../services/global-question.service';
import {PolicyService} from '../../../policy/services/policy.service';

declare var jQuery: any;
declare function notify(): any;

@Component({
    selector: 'app-assign-broker-modal',
    templateUrl: './assign-broker-modal.component.html',
    styleUrls: ['./assign-broker-modal.component.scss'],
    standalone: false
})
export class AssignBrokerModalComponent implements OnChanges {
  @Input() selectedRecord: any;
  @Input() mode: string;
  @Input() brokerages: any[] = [];
  @Output() saved = new EventEmitter<void>();

  brokerUsers: any[] = [];
  selectedBrokerage: number = null;
  selectedBrokerUser: number = null;
  isLoading = false;
  private editSessionId: string = null;
  notify: any;

  constructor(
    public globalQuestionService: GlobalQuestionService,
    private policyService: PolicyService
  ) {
    this.notify = notify();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedRecord?.currentValue) {
      this.selectedBrokerage = null;
      this.selectedBrokerUser = null;
      this.brokerUsers = [];
      this.editSessionId = null;
    }
  }

  onBrokerageChange(): void {
    this.selectedBrokerUser = null;
    this.brokerUsers = [];
    if (!this.selectedBrokerage) { return; }
    const params = new Map<string, string>();
    params.set('broker_id', this.selectedBrokerage.toString());
    this.globalQuestionService.runCommandNew('usp_GetBrokerUsers', params)
      .subscribe({ next: (result: any[]) => { this.brokerUsers = result ?? []; } });
  }

  confirm(): void {
    if (!this.selectedBrokerage || !this.selectedBrokerUser || this.isLoading) { return; }
    this.isLoading = true;
    if (this.mode === 'Quotes') {
      this.saveQuote();
    } else {
      this.savePolicy();
    }
  }

  private saveQuote(): void {
    const sid = this.selectedRecord?.session_id?.toString();
    const fid = this.selectedRecord?.flow_id ?? 0;
    this.globalQuestionService.saveAnswer(sid, 632, 0, '0', this.selectedBrokerage.toString(), 0, null, fid).pipe(
      concatMap(() => this.globalQuestionService.saveAnswer(sid, 2511, 0, '0', this.selectedBrokerUser.toString(), 0, null, fid))
    ).subscribe({
      next: () => { this.onSuccess(); },
      error: () => { this.onError(); }
    });
  }

  private savePolicy(): void {
    this.policyService.editPolicy(this.selectedRecord?.policy_id?.toString(), this.selectedRecord?.session_id?.toString())
      .subscribe({
        next: (result: any[]) => {
          if (!result?.length) { this.onError(); return; }
          this.editSessionId = result[0]?.session_id?.toString();
          this.globalQuestionService.saveAnswer(this.editSessionId, 632, 0, '0', this.selectedBrokerage.toString(), 0, null, 0).pipe(
            concatMap(() => this.globalQuestionService.saveAnswer(this.editSessionId, 2511, 0, '0', this.selectedBrokerUser.toString(), 0, null, 0)),
            concatMap(() => {
              const today = new Date().toISOString().split('T')[0];
              return this.policyService.savePolicyUpdate(this.editSessionId, 1, 0, '0', today, today);
            }),
            concatMap(() => this.policyService.submitPolicyUpdates(this.editSessionId))
          ).subscribe({
            next: () => { this.editSessionId = null; this.onSuccess(); },
            error: () => { this.rollbackAndError(); }
          });
        },
        error: () => { this.onError(); }
      });
  }

  cancel(): void {
    if (this.editSessionId) {
      const params = new Map<string, string>();
      params.set('policy_id', this.selectedRecord?.policy_id?.toString());
      params.set('curr_session_id', this.editSessionId);
      params.set('select', '0');
      params.set('rollback', '1');
      params.set('rollback_v2', '1');
      this.globalQuestionService.runCommandNew('editPolicy', params)
        .subscribe({ next: () => { this.editSessionId = null; } });
    }
    if (this.mode === 'Policies') {
      this.notify.init({ message: '<strong>Changes discarded.</strong>', icon: 'info', style: 'info', size: 'lg', close: true, speed: 350, duration: 5000 });
    }
    jQuery('#modal-assign-broker').modal('hide');
  }

  private rollbackAndError(): void {
    if (this.editSessionId) {
      const params = new Map<string, string>();
      params.set('policy_id', this.selectedRecord?.policy_id?.toString());
      params.set('curr_session_id', this.editSessionId);
      params.set('select', '0');
      params.set('rollback', '1');
      params.set('rollback_v2', '1');
      this.globalQuestionService.runCommandNew('editPolicy', params)
        .subscribe({ next: () => { this.editSessionId = null; this.onError(); } });
    } else {
      this.onError();
    }
  }

  private onSuccess(): void {
    this.isLoading = false;
    this.notify.init({ message: '<strong>Changes saved.</strong>', icon: 'complete', style: 'success', size: 'lg', close: true, speed: 350, duration: 5000 });
    this.saved.emit();
    jQuery('#modal-assign-broker').modal('hide');
  }

  private onError(): void {
    this.isLoading = false;
    this.notify.init({ message: '<strong>Failed to assign broker. Please try again.</strong>', icon: 'info', style: 'info', size: 'lg', close: true, speed: 350, duration: 5000 });
  }
}
